module.exports = "<div class=\"q-link-list-container q-display-none-at-md q-overflow-auto\"> <span class=qllc-wrap> {%= linkList %} </span> </div> <div class=\"q-display-none q-block-at-md\"> <select id=\"{%- dropdownId %}\" name=\"{%- dropdownName %}\" class=\"select2-select q-input filter-by-select\" style=width:100% data-error-placement-append-closest=div data-s2-placeholder=\"{%- dropdownPlaceholder %}\" data-s2-minimum-results-for-search=\"{%- dropdownMinResultsForSearch %}\"> {%= optionList %} </select> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/sharedHtml/linkGroup/linkListWrap.html
// module id = 1447
// module chunks = 1